import { Alert, Button } from "react-bootstrap";
import { Modal, MuniSpinner2 } from "../../../components";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { useEffect, useState } from "react";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import FileError from "../../../components/Icons/ErrorFile";

const ModalVerActa = () => {

    //? ESTADOS GLOBALES
    const { alertasBloqueo, alertasNoBloqueo, archivos } = useActaDetalleStore();
    const { modals, handlerModal } = useGeneralAppStore();

    useEffect(() => {
        return () => {
            handlerModal({ modal: false, modalName: "ver_acta" })
        }
    }, [])

    const [opc, setOpc] = useState(0);
    const [pdfSelect, setPdfSelect] = useState(
        archivos?.actas?.length > 0 ? archivos?.actas[0] : null
    );

    return (
        <>
            <Modal
                show={modals.includes('ver_acta')}
                size={"lg"}
                onHide={() => handlerModal({ modal: false, modalName: "ver_acta" })}
                title={() => "Acta PDF"}
            >
                {archivos.actas.map((archivo, index) => {
                    return (
                        <span
                            className={`fw-bold  py-1 px-2 ${opc == index && "text-light"}`}
                            style={{ cursor: "pointer", backgroundColor: opc == index && "#323639" }}
                            key={index}
                            onClick={() => {
                                setPdfSelect(archivo);
                                setOpc(index);
                            }}
                        >
                            Acta {archivo.tipo_acta}
                        </span>
                    );
                })}
                <div className="col w-100" style={{ aspectRatio: "3/4" }}>
                    {pdfSelect?.es_pesada ? (
                        <div className="d-flex  justify-content-center h-100 align-items-center border border-1 border-secondary">
                            <label
                                className="py-3 px-5 rounded text-danger  d-flex gap-2"
                                style={{ border: "4px dotted gray", width: "fit-content" }}
                            >
                                <FileError />
                                El PDF no se puede mostrar, es muy pesado
                            </label>
                        </div>
                    ) : (
                        <object type="application/pdf" data={pdfSelect?.file} height={"100%"} width={"100%"} />
                    )}
                </div>

            </Modal>
        </>
    );
}
export default ModalVerActa;